export default {"spinnerWrapper":"_spinnerWrapper_1c4pl_1","spinner":"_spinner_1c4pl_1","rotation":"_rotation_1c4pl_1"};